import { forwardRef, useState } from 'react';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material/TextField';

interface PasswordTextFieldProps extends Omit<TextFieldProps, 'type'> {
  onCopy?: () => void;
}

export const PasswordTextField = forwardRef<HTMLDivElement, PasswordTextFieldProps>(
  function PasswordTextField({ onCopy, slotProps, ...props }, ref) {
    const [visible, setVisible] = useState(false);

    return (
      <TextField
        {...props}
        ref={ref}
        slotProps={{
          ...slotProps,
          input: {
            ...(slotProps?.input as Record<string, any>),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => setVisible((v) => !v)}>
                  {visible ? (
                    <VisibilityOffIcon fontSize="small" />
                  ) : (
                    <VisibilityIcon fontSize="small" />
                  )}
                </IconButton>
                {onCopy && (
                  <IconButton size="small" onClick={onCopy}>
                    <ContentCopyIcon fontSize="small" />
                  </IconButton>
                )}
              </InputAdornment>
            ),
          },
        }}
        type={visible ? 'text' : 'password'}
      />
    );
  }
);
